import CommonButton from "@components/CommonButton";
import { IconFileEmpty } from "@icons/common";
import classNames from "classnames";
import { Trans } from "react-i18next";

interface EmptyProps {
  image: string;
  tips: string;
  label?: string | JSX.Element;
  handleBtnClick?: () => void;
  className?: string;
  btnType?: "normal" | "gradient"; // 新增按钮类型属性，默认为primary，可根据需要设置为secondary
  card?: boolean;
  size?: "medium" | "small";
}
const Empty = ({
  image: _image,
  tips,
  label,
  handleBtnClick,
  className,
  btnType = "normal",
  card = false,
  size = "medium",
}: EmptyProps) => {
  return (
    <div
      className={classNames(
        "relative flex flex-col items-center justify-center p-[12px] h-full",
        !card && "shadow-none border-none",
        className,
      )}
    >
      <IconFileEmpty
        className={classNames("w-[80px] h-[80px]", size === "small" ? "w-[80px] h-[80px]" : "w-[120px] h-[120px]")}
      />
      <div className="text-[#999] text-[14px] mt-[12px]">
        <Trans>{tips}</Trans>
      </div>
      {typeof label === "string" ? (
        <div className="mt-[16px]">
          {btnType === "gradient" && (
            <CommonButton className="h-[32px] min-w-[120px]" onClick={() => handleBtnClick && handleBtnClick()}>
              <Trans>{label}</Trans>
            </CommonButton>
          )}
          {btnType === "normal" && (
            <CommonButton type="primary" onClick={() => handleBtnClick && handleBtnClick()}>
              <Trans>{label}</Trans>
            </CommonButton>
          )}
        </div>
      ) : (
        label
      )}
    </div>
  );
};

export default Empty;
